export enum THEMATIC {
  BANK = 'bank',
  LETTER_PACKAGE = 'letter-package',
  DT = 'dt',
  INFORMATIONS_FINANCIERES = 'informations-financieres',
  INNOVATION = 'innovation',
  CULTURE = 'culture',
  LOGISTIC = 'logistic',
  MEDIA = 'medias',
  PARTNERSHIP = 'partnership',
  HUMAN_RESOURCES = 'human-resource',
  NOUVEAUX_SERVICES = 'nouveaux-services',
  GROUPE = 'group',
  NUMERIQUE = 'numeric',
  ECOLOGY = 'ecology',
  PHILATELY = 'philately',
}
